export default {"src":"/polygon/_next/static/media/book-light.e0bb2bda.svg","height":24,"width":24};